/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockProfile as BlockModel } from '@staffino/model';
import { Box, Image, Paragraph } from '@staffino/primitive-controls';

// TODO: define this in model
type Target = {
  id: string;
  name: string;
  description?: string;
  imageUrl: string;
};

type Props = {
  block: BlockModel;
  targetLineage: Target[];
};
const ProfileBlock = ({ block, targetLineage = [] }: Props) => {
  const showName = block.showName ?? true;
  const level = block.level ?? 0;
  const target = targetLineage[level];
  const parent = targetLineage[level + 1];
  const size = block.size === 'small' ? 80 : 120;
  return (
    <Box alignItems="center">
      <Image
        source={{ uri: target?.imageUrl, width: size, height: size }}
        borderRadius="50%"
        border="solid 1px rgba(163, 178, 191, 0.2)"
      />
      {parent?.imageUrl && block.showParentDetails && (
        <Image
          source={{ uri: parent?.imageUrl, width: 40, height: 40 }}
          borderRadius="50%"
          margin={size === 120 ? '-40px 0px 0px 80px' : '-30px 0px 0px 50px'}
        />
      )}
      {showName && (
        <Paragraph
          color="text"
          fontWeight="bold"
          mt="0.5rem"
          lineHeight="normal"
        >
          {target?.name}
        </Paragraph>
      )}
      {target?.description && block.showDetails && (
        <Paragraph color="lightText" fontSize="0.875rem" lineHeight="normal">
          {target.description}
        </Paragraph>
      )}
      {parent?.description && block.showParentDetails && (
        <Paragraph color="lightText" fontSize="0.875rem" lineHeight="normal">
          {parent.description}
        </Paragraph>
      )}
    </Box>
  );
};

export default ProfileBlock;
